import React from 'react';
import {
  PictureAsPdf,  // PDF
  Description,    // Word/Doc
  GridOn,         // Excel
  Code,           // Código genérico
  Image,          // Imagens
  InsertDriveFile, // Arquivo genérico
  Slideshow,       // PowerPoint
  Archive,         // Arquivos compactados
  MusicNote,       // Áudio
  Movie,           // Vídeo
  DataObject,       // JSON/XML
  Settings
} from '@mui/icons-material';

interface FileIconProps {
  extension: string;
  fontSize?: 'small' | 'medium' | 'large';
  color?: 'primary' | 'secondary' | 'action' | 'error' | 'disabled' | 'inherit';
}

const FileIcon: React.FC<FileIconProps> = ({ extension, fontSize = 'small', color = 'inherit' }) => {
  // Normaliza a extensão para minúsculas
  const ext = extension.toLowerCase();

  // Mapeamento de extensões para ícones
  const iconMap: Record<string, JSX.Element> = {
    // Documentos
    pdf: <PictureAsPdf fontSize={fontSize} color="error" />,
    doc: <Description fontSize={fontSize} color="primary" />,
    docx: <Description fontSize={fontSize} color="primary" />,
    txt: <Description fontSize={fontSize} color="action" />,
    rtf: <Description fontSize={fontSize} color="action" />,

    // Planilhas
    xls: <GridOn fontSize={fontSize} color="success" />,
    xlsx: <GridOn fontSize={fontSize} color="success" />,
    csv: <GridOn fontSize={fontSize} color="success" />,

    // Apresentações
    ppt: <Slideshow fontSize={fontSize} color="warning" />,
    pptx: <Slideshow fontSize={fontSize} color="warning" />,

    // Códigos
    js: <Code fontSize={fontSize} color="secondary" />,
    ts: <Code fontSize={fontSize} color="secondary" />,
    jsx: <Code fontSize={fontSize} color="secondary" />,
    tsx: <Code fontSize={fontSize} color="secondary" />,
    py: <Code fontSize={fontSize} color="primary" />,
    java: <Code fontSize={fontSize} color="primary" />,
    c: <Code fontSize={fontSize} color="primary" />,
    cpp: <Code fontSize={fontSize} color="primary" />,
    h: <Code fontSize={fontSize} color="primary" />,
    html: <Code fontSize={fontSize} color="warning" />,
    css: <Code fontSize={fontSize} color="primary" />,
    scss: <Code fontSize={fontSize} color="primary" />,
    json: <DataObject fontSize={fontSize} color="secondary" />,
    xml: <DataObject fontSize={fontSize} color="secondary" />,

    // Imagens
    jpg: <Image fontSize={fontSize} color="primary" />,
    jpeg: <Image fontSize={fontSize} color="primary" />,
    png: <Image fontSize={fontSize} color="primary" />,
    gif: <Image fontSize={fontSize} color="primary" />,
    svg: <Image fontSize={fontSize} color="primary" />,
    bmp: <Image fontSize={fontSize} color="primary" />,

    // Arquivos compactados
    zip: <Archive fontSize={fontSize} color="action" />,
    rar: <Archive fontSize={fontSize} color="action" />,
    '7z': <Archive fontSize={fontSize} color="action" />,
    tar: <Archive fontSize={fontSize} color="action" />,
    gz: <Archive fontSize={fontSize} color="action" />,

    // Mídia
    mp3: <MusicNote fontSize={fontSize} color="action" />,
    wav: <MusicNote fontSize={fontSize} color="action" />,
    mp4: <Movie fontSize={fontSize} color="action" />,
    avi: <Movie fontSize={fontSize} color="action" />,
    mov: <Movie fontSize={fontSize} color="action" />,
    mkv: <Movie fontSize={fontSize} color="action" />,

    // Configurações
    yml: <Settings fontSize={fontSize} color="action" />,
    yaml: <Settings fontSize={fontSize} color="action" />,
    env: <Settings fontSize={fontSize} color="action" />,
    ini: <Settings fontSize={fontSize} color="action" />,
    cfg: <Settings fontSize={fontSize} color="action" />,
  };

  // Retorna o ícone correspondente ou um ícone padrão
  return iconMap[ext] || <InsertDriveFile fontSize={fontSize} color={color} />;
};

export default FileIcon;